import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';

const NotFound = () => {
  return (
    <main className="not-found-wrapper">
      <div className="not-found-background">
        <img src="/images/404.webp" alt="" className="not-found-image" />
      </div>
      <div className="not-found-content">
        <h1 className="heading-style-h1">404</h1>
        <div className="max-width-medium">
          <div>That page does not exist.</div>
        </div>
        <Link to="/" className="button w-inline-block">
          <div className="button-inner">
            <div className="button-inner-text">Back Home</div>
            <div className="button-inner-text-hover">Back Home</div>
          </div>
        </Link>
      </div>
      <div className="not-found-footer">
        <Footer />
      </div>
    </main>
  );
};

export default NotFound;

